var ExpandableStudentListSelector = require("components/data/exports/ExpandableStudentListSelector")
var TeacherSelector = require("components/data/exports/TeacherSelector")

class UserSelectorDispatcher extends React.Component {
    constructor(props) {
        super(props);
    }

    dispatch() {
        var { persistentData } = this.props
        // return correct selector based on the selected organization type
        if (persistentData && persistentData.selectedOrganizationType == 'per-teacher') {
            return <TeacherSelector {...this.props} />
        } else {
            return <ExpandableStudentListSelector {...this.props} />
        }
    }

    render() {
        return this.dispatch();
    }
}

module.exports = UserSelectorDispatcher;


// WEBPACK FOOTER //
// ./modules/components/data/exports/UserSelectorDispatcher.js